Pegasus.Modal = Ember.Object.extend({
  title: Em.required(),
  didCancel: function(){
    this.set('controller.presenter', null);
  },
  didSubmit: function(){
    this.set('controller.presenter', null);
  },
  footerTemplateName: 'modals/footer',
  bodyTemplateName: 'modals/empty',
  cancelText: Pegasus.computed.t('g.cancel'),
  submitText: Pegasus.computed.t('g.submit'),

  willClose: Em.K,

  headerClassName: 'modal-header',
  bodyClassName: 'modal-body',
  footerClassName: 'modal-footer'
});
